import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { CircularProgress, ListItemIcon, ListItemSecondaryAction, ListItemText, MenuItem, Switch } from "@mui/material";
import { useRecordContext, useUpdate } from "react-admin";
import { type DeepPartial } from "ts-essentials";
import { Student } from "../providers/studentsProvider";

export function ArchivedStudentMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const student = useRecordContext<Student>();
  const [update, { isLoading }] = useUpdate();

  if (!student) {
    return null;
  }

  const handleToggle = (newValue: boolean) => {
    const data: DeepPartial<Student> = { archived: newValue };

    return runSafely(
      () =>
        update("students", {
          id: student.id,
          data,
          previousData: student,
        }),
      {
        successMessage: "Schüler erfolgreich archiviert.",
        errorMessage: "Schüler konnte nicht archiviert werden.",
        onSuccess: closeMenu,
      },
    );
  };

  return (
    <MenuItem onClick={() => !isLoading && handleToggle(!student.archived)}>
      <ListItemIcon>
        <ArchiveOutlinedIcon />
      </ListItemIcon>
      <ListItemText sx={{ minWidth: "240px" }}>Schüler archiviert</ListItemText>
      <ListItemSecondaryAction>
        {isLoading ? (
          <CircularProgress size={20} />
        ) : (
          <Switch
            edge="end"
            checked={!!student.archived}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => handleToggle(event.target.checked)}
            disabled={isLoading}
            inputProps={{ "aria-label": "Schüler archiviert" }}
          />
        )}
      </ListItemSecondaryAction>
    </MenuItem>
  );
}
